import { createSlice } from "@reduxjs/toolkit";
import updateCaseTiming from "@custom/rtk-apis/Setting/updateCaseTiming";

const initialState = {
    status: "",
    result: {},
    msg: "",
    loading: false,
    error: ""
};

const updateCaseTimingSlice = createSlice({
    name: "updateCaseTimingSlice",
    initialState,
    reducers: {
        clearUpdateCaseTimingState: (state: any) => {
            state.status = '';
            state.result = {};
            state.msg = '';
            state.loading = false;
            state.error = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateCaseTiming.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(updateCaseTiming.fulfilled, (state, { payload }) => {
                console.log("🚀 ~ .addCase ~ payload:", payload)
                state.loading = false;
                state.status = payload.status;
                state.result = payload.result;
                state.msg = payload.msg;
            })
            .addCase(updateCaseTiming.rejected, (state, { payload }) => {
                state.result = payload;
                state.loading = false;
            });
    },
});

export default updateCaseTimingSlice.reducer;
export const { clearUpdateCaseTimingState } = updateCaseTimingSlice.actions;
